import { observer } from 'mobx-react';
import { Option } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';

const styles = require('./OptionsFull.scss');

export interface OptionsFormProps {
    option: Option;
}

@observer
export default class OptionsForm extends React.Component<OptionsFormProps, {}> {
    render() {
        let { option } = this.props;
        let { fullOptionFormSettings, key, titleStringKey, hideTitleInFullOptions } = option;

        if (!fullOptionFormSettings) {
            return null;
        }

        let optionAriaId = `options-full-${key}`;

        return (
            <div className={styles.optionEntry}>
                {!hideTitleInFullOptions && (
                    <div className={styles.header} role="heading" aria-level={4}>
                        <span className={styles.title} id={optionAriaId}>
                            {strings[titleStringKey]}
                        </span>
                    </div>
                )}
                <div className={styles.formContainer} aria-labelledby={optionAriaId}>
                    {fullOptionFormSettings.render()}
                </div>
            </div>
        );
    }
}
